import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { fetchFilterOptions } from '../actions';
import { createUser, cancelAddUser, changeNewUserAttribute } from '../actions';

// Material UI Library
import Drawer from 'material-ui/Drawer';
import AppBar from 'material-ui/AppBar';
import IconButton from 'material-ui/IconButton';
import NavigationClose from 'material-ui/svg-icons/navigation/close';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';

class NewUserDrawer extends Component {

  handleCreateUser = () => {
    this.props.dispatch(createUser(this.props.newUser.toJS()));
  };

  handleChange = (attribute, e) => {
    this.props.dispatch(changeNewUserAttribute(attribute, e.target.value));
  };

  handleCancel = () => {
    this.props.dispatch(cancelAddUser());
  };


  render() {
    const drawerStyle = {
      position: 'absolute',
      top: 'auto',
      overflowX: 'hidden',
    };

    return (
      <Drawer
        open={this.props.open}
        containerStyle={drawerStyle}
        openSecondary={true}
        width={400}
      >
        <AppBar
          title="New User"
          showMenuIconButton={false}
          iconElementRight={
            <IconButton onTouchTap={this.handleCancel}>
              <NavigationClose />
            </IconButton>
          }
        >
        </AppBar>
        <div style={{ padding: 10 }}>
          <TextField
            id="user-firstname"
            placeholder="First Name"
            fullWidth={true}
            value={this.props.newUser.firstName}
            onChange={this.handleChange.bind(this, 'firstName')}
          />
          <TextField
            id="user-lastname"
            placeholder="Last Name"
            fullWidth={true}
            value={this.props.newUser.lastName}
            onChange={this.handleChange.bind(this, 'lastName')}
          />
          <TextField
            id="user-email"
            placeholder="Email"
            fullWidth={true}
            value={this.props.newUser.email}
            onChange={this.handleChange.bind(this, 'email')}
          />
          <RaisedButton
            label="Create"
            primary={true}
            style={{ margin: 12 }}
            onClick={this.handleCreateUser}
          />
        </div>
        </Drawer>
    );
  }
}

function mapStateToProps(state) {
  return {
    newUser: state.get('users').get('items').get('-1') || Map(),
  };
}

export default connect(mapStateToProps)(NewUserDrawer);



/** WEBPACK FOOTER **
 ** ./containers/NewUserDrawer.js
 **/